import classNames from "classnames";
import * as React from "react";
import "./PanelCTA.scss";

interface PanelCTAProps {
  className?: string;
  backgroundImage: string;
}

export const PanelCTA: React.FunctionComponent<PanelCTAProps> = (props) => {
  return (<div className={classNames("PanelCTA", props.className)} style={{ backgroundImage: `url(${props.backgroundImage})` }}>
      {props.children}
  </div>);
};
